/**
 * Rooster plugin that exposes the editor ref for direct editor manipulation
 */ export class RoosterGetEditorRefPlugin {
    getEditorRef() {
        return this.editorRef;
    }
    /**
     * Gets the name of the plugin
     */ getName() {
        return "RoosterGetEditorRefPlugin";
    }
    /**
     * Plugin initialize lifecycle hook
     */ initialize(editor) {
        this.editorRef = editor;
    }
    /**
     * Plugin dispose lifecycle hook
     */ dispose() {
        this.editorRef = null;
    }
    /**
     * Plugin event hook
     */ onPluginEvent(event) {
    /* do nothing */ }
    constructor(){
        this.editorRef = null;
    }
}
